/*
 *
 * Header
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import { makeSelectActiveTab } from './selectors';
import reducer from './reducer';
import { RootState } from './types';
import Img from '../../components/Img';
import Logo from 'assets/images/logo.png';
import styled from 'styled-components/macro';
import { FiRotateCcw, FiRotateCw } from 'react-icons/fi';
import StyledConfiguratorTab from './ConfiguratorTab';
import { switchTabAction } from 'containers/Header/actions';
import {
  historyRedoAction,
  historyUndoAction,
} from 'containers/Configurator/actions/history';
import {
  makeSelectIsRedoActive,
  makeSelectIsUndoActive,
} from 'containers/Configurator/selectors/history';
import TabNames from './TabNames';
import { makeSelectShelvesLevelSelected } from 'containers/Configurator/selectors/selection';
import { useTranslation } from 'react-i18next';
import saga from './saga';
import { useInjectSaga } from 'utils/injectSaga';
import { useMedia } from 'use-media';
import { shelvesSelectionAction } from 'containers/Configurator/actions/selection';
import { displayTutorialAction } from 'containers/TutorialTour/actions';
import LanguageSelector from '../LanguageSelector';
import { FurnitureEditorContext } from '../../lib/constraintsChecker/FurnitureEditor';
import { makeSelectContext } from '../Configurator/selectors/general';
import { makeSelectDisplayFurniturePanel } from '../FurniturePanel/selectors';

interface StateProps {
  context: FurnitureEditorContext;
  activeTab: TabNames;
  isUndoActive: boolean;
  isRedoActive: boolean;
  isHide: boolean;
  selectedShelfLevel: number[];
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  context: makeSelectContext(),
  activeTab: makeSelectActiveTab(),
  isUndoActive: makeSelectIsUndoActive(),
  isRedoActive: makeSelectIsRedoActive(),
  selectedShelfLevel: makeSelectShelvesLevelSelected(),
  isHide: makeSelectDisplayFurniturePanel(),
});

function Header() {
  const key = 'header';
  useInjectReducer({ key: key, reducer: reducer });
  useInjectSaga({ key: key, saga: saga });
  const dispatch = useDispatch();
  const {
    context,
    activeTab,
    isUndoActive,
    isRedoActive,
    selectedShelfLevel,
    isHide,
  } = useSelector(mapStateToProps);
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });

  const changeTab = (tabName: TabNames) => {
    if (activeTab !== tabName) dispatch(switchTabAction(tabName));
    else if (tabName === TabNames.shelves) dispatch(shelvesSelectionAction([]));
  };

  function startTutorial() {
    dispatch(displayTutorialAction(true));
  }

  if (isHide && isMobile) {
    return null;
  }

  return (
    <HeaderWrapper>
      <div className="flex lg:ml-4">
        <div className="flex items-center justify-center">
          <Img
            src={Logo}
            alt="Kewlox-logo"
            className="sethidden lg:block h-6"
          />
        </div>
        <div className="configurator-tabs lg:ml-2 flex p-0 items-end">
          <StyledConfiguratorTab
            isActive={activeTab === TabNames.cabinet}
            onClick={() => changeTab(TabNames.cabinet)}
            mobile={isMobile ? 1 : 0}
            className=""
          >
            {t('Cabinet')}
          </StyledConfiguratorTab>
          <StyledConfiguratorTab
            isActive={
              activeTab === TabNames.shelves &&
              (!selectedShelfLevel || selectedShelfLevel.length === 0)
            }
            onClick={() => changeTab(TabNames.shelves)}
            mobile={isMobile ? 1 : 0}
            className="tuto-step-shelves-tab"
          >
            {t('Shelves')}
          </StyledConfiguratorTab>
          {activeTab === TabNames.shelves &&
          selectedShelfLevel &&
          selectedShelfLevel.length > 0 ? (
            <StyledConfiguratorTab isActive={true} mobile={isMobile ? 1 : 0}>
              <i>
                {activeTab === TabNames.shelves &&
                selectedShelfLevel &&
                selectedShelfLevel.length === 1
                  ? `${t('Shelf')} ${selectedShelfLevel[0] + 1}`
                  : t('Shelves') + ' *'}
              </i>
            </StyledConfiguratorTab>
          ) : null}
          {/*<StyledConfiguratorTab
          isActive={activeTab === TabNames.options}
          onClick={() => {
            console.log('TODO: OPEN Tab options');
          }}
          mobile={isMobile ? true : false}
        >
          {t('Options')}
        </StyledConfiguratorTab>*/}
        </div>
      </div>
      {!isMobile && (
        <div className="header-action flex items-center lg:ml-12">
          <div className="history-btn flex mt-1 items-center">
            <div className="undo mx-2 py-2">
              <button
                onClick={() => dispatch(historyUndoAction())}
                disabled={!isUndoActive}
              >
                <FiRotateCcw className="h-4 w-4" />
              </button>
            </div>
            <div className="redo mx-2 py-2">
              <button
                onClick={() => dispatch(historyRedoAction())}
                disabled={!isRedoActive}
              >
                <FiRotateCw className="h-4 w-4" />
              </button>
            </div>
          </div>
          {process.env.NODE_ENV !== 'production' ||
          context !== FurnitureEditorContext.webShop ? (
            <div className="text-sm mx-1">
              <LanguageSelector />
            </div>
          ) : null}

          {/*<div className="sethidden lg:flex items-center mx-2 pxy-2 mr-8">
            <FiHelpCircle className="h-5 w-5 mr-2" />
            <button onClick={startTutorial}>{t('Help')}</button>
          </div>*/}

          {/*<RangeSelector />*/}
        </div>
      )}
    </HeaderWrapper>
  );
}

const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export default Header;
